// src/components/generateThreadTitle.js
export async function generateThreadTitle(messages) {
    const slice = messages.slice(-8).map(m => `${m.role}: ${m.content}`).join("\n\n");
    const prompt = `Name this chat thread in 3–5 words.
  Rules:
  - Title Case
  - No quotes
  - Be specific if possible
  - If unclear, output: General Collaborator Chat
  
  Conversation:
  ${slice}
  
  ONLY OUTPUT THE TITLE TEXT.`;
  
    const resp = await fetch("/api/openai", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ prompt, model: "gpt-4o-mini", temperature: 0.2 }),
    });
    if (!resp.ok) throw new Error("title_generation_failed");
    const data = await resp.json();
    return (data.result || "").trim();
  }
  
